import { Progress } from "native-base";

export default Progress;